import { useQuery as useUrqlQuery } from 'urql';
import { usePropertyId } from '../../contexts/PropertyIdContext/PropertyIdContext';
import { isHopefullyDomEnvironment } from '../../helpers/IsHopefullyDomEnvironment';
import { beforeYouBuyTimelineQuery } from './beforeYouBuyTimelineQuery';
import { useFeatureRollout } from '@rea-argonaut/experiment';

export const useBeforeYouBuyTimelineQuery = () => {
  const isClientSideRender = isHopefullyDomEnvironment();
  const propertyId = usePropertyId();
  const toggleBYBLegalDisclaimers = useFeatureRollout('byb_legal_disclaimers').isEnabled();

  const [urqlResult] = useUrqlQuery({
    query: beforeYouBuyTimelineQuery,
    pause: !isClientSideRender,
    variables: {
      propertyId,
      toggleBYBLegalDisclaimers,
    },
  });

  return urqlResult;
};
